import type { Location } from '#domain/Location.ts';

import type { ApiCoordinates, ApiLocation } from '../model/types.ts';

export const mapLocation = (location: ApiLocation, coordinates?: ApiCoordinates): Location => {
    return {
        street: location.street,
        city: location.city,
        zipCode: location.zip_code,
        country: location.country,
        latitude: coordinates?.latitude,
        longitude: coordinates?.longitude,
    };
};

export const mapLocationToApi = (location: Location): ApiLocation => ({
    street: location.street,
    city: location.city,
    zip_code: location.zipCode,
    country: location.country,
});
